import React, { Component, Fragment } from 'react'
import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import UserLogin from '../components/common/UserLogin'


class UserLoginPage extends Component {
     componentDidMount() {
          window.scroll(0, 0)
     }

     render() {


          //setUser এবং user নামের দুটি প্রপ্স রয়েছে, যা UserLoginPage এর প্যারেন্ট কম্পোনেন্ট AppRoute থেকে এসেছে বা পাস করা হয়েছে বা পাঠানো হয়েছে 
          //AppRoute এভাবে <UserLoginPage setUser={this.setUser} user={this.state.user} />,  UserLoginPage-কে রেন্ডার করে বা করেছে
          //যেহেতু AppRoute কম্পোনেন্টটি UserLoginPage-কে রেন্ডার করে এবং সেই সাথে setUser এবং user প্রপার্টিগুলো UserLoginPage-এ পাস করে, 
          //সেহেতু AppRoute, কে UserLoginPage-এর প্যারেন্ট কম্পোনেন্ট বলা হয়। 
          //setUser: এটি একটি ফাংশন যা প্যারেন্ট কম্পোনেন্ট AppRoute থেকে পাঠানো হয় এবং ইউজারের তথ্য সেট করার জন্য ব্যবহৃত হয়।
          //user: এটি ইউজারের বর্তমান ডেটা ধরে রাখে, যা UserLogin কম্পোনেন্টে পাঠানো হয়, যেন লগইন হওয়া ইউজারের তথ্য উপলব্ধ থাকে।
          //<UserLogin setUser={setUser} user={user} /> এই লাইনে UserLogin কম্পোনেন্টে setUser এবং user প্রপ্স হিসেবে পাঠানো হচ্ছে, 
          //ফলে UserLogin কম্পোনেন্টের মধ্যে এই প্রপ্সগুলো ব্যবহারের জন্য উপলব্ধ হবে।
          // user প্রপ্সটি UserLoginPage থেকে UserLogin কম্পোনেন্টে পাঠানো হলেও, UserLogin কম্পোনেন্টের মধ্যে user প্রপ্সের কোনো ব্যবহার নেই।
          // user প্রপ্সটি একেবারে সরিয়ে ফেলা উচিত.
          const setUser = this.props.setUser;
          const user = this.props.user;

          return (
               <Fragment>
                    <div className="Desktop">
                         <NavMenuDesktop />
                    </div>

                    <div className="Mobile">
                         <NavMenuMobile />
                    </div>

                    <UserLogin setUser={setUser} user={user} />


                    <div className="Desktop">
                         <FooterDesktop />
                    </div>

                    <div className="Mobile">
                         <FooterMobile />
                    </div>

               </Fragment>
          )
     }
}

export default UserLoginPage
